const CATEGORIES = [
    {
        name: "Patterns",
        id: "patterns"
    },
    {
        name: "Stripes",
        id: "stripes"
    },
    {
        name: "Circular Gradients",
        id: "circles"
    },
    {
        name: "Lines and Angles (Angular)",
        id: "angular"
    },
    {
        name: "Standard (Smooth) Gradients",
        id: "standard"
    },
    {
        name: "Backgrounds",
        id: 'backgrounds'
    },
    {
        name: "Grids, Plaids, and Checks",
        id: "grids"
    },
    {
        name: "Squares, Diamonds, and Other Shapes",
        id: "shapes"
    },
    {
        name: "Unique and Miscellaneous",
        id: "other"
    },
]

export default CATEGORIES